import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/Button';

export const Hero = () => {
  return (
    <div className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: 'url("https://images.unsplash.com/photo-1616843221271-a3447ca74df3?auto=format&fit=crop&q=80&w=1920")',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
        }}
      >
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-primary-dark/90 to-primary/40" />
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10 text-white pt-20">
        <div className="max-w-3xl animate-fade-in-up">
          <h2 className="text-secondary font-bold uppercase tracking-widest mb-4 text-sm md:text-base">
            Premium Kvalitet • Leskovac
          </h2>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold leading-tight mb-6">
            ALU & PVC Stolarija <br />
            <span className="text-secondary">Po Vašoj Meri</span>
          </h1>
          <p className="text-lg md:text-xl text-gray-200 mb-8 max-w-2xl leading-relaxed">
            Kvalitetna izrada, moderna tehnologija i profesionalna montaža. 
            Vaš dom zaslužuje najbolje rešenje za energetsku efikasnost i sigurnost.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link to="/usluge">
              <Button size="lg" className="w-full sm:w-auto">
                Pogledajte Usluge
              </Button>
            </Link>
            <Link to="/kontakt">
              <Button variant="white" size="lg" className="w-full sm:w-auto">
                Pozovite Odmah
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce text-white/50">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center p-1">
          <div className="w-1 h-2 bg-white/50 rounded-full" />
        </div>
      </div>
    </div>
  );
};
